import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'

export interface ButlerListItemStockProps {
  stock?: number
  quantity?: number
}

export const ButlerListItemStock = (props: ButlerListItemStockProps) => {
  const { stock = 0, quantity = 0 } = props
  const outOfStock = quantity > stock
  return (
    <Text variant="caption" color={colors.grey800}>
      剩餘數量
      {' '}
      {stock}
      {outOfStock && ' (缺貨)'}
    </Text>
  )
}
